import React from 'react'

import { COLORS } from 'theme'
import { CardText, SingleCard, TopHeader1 } from './style'

const EmptyCard = ({
  background = COLORS.BLUE_T_95,
  padding = '15px 25px',
  width = 'auto',
  height,
  state,
  current,
}) => {
  return (
    <SingleCard
      background={current && state == current ? COLORS.BLUE_T_80 : background}
      padding={padding}
      width={width}
      column
      flexStart
      height={height}
      styleProps={false}
    >
      <br></br>
      <br></br>
      <TopHeader1 row spaceBetween alignCenter>
        <CardText>No Interview Scheduled</CardText>
      </TopHeader1>
    </SingleCard>
  )
}

export default EmptyCard
